import { render } from "./passed.vue?vue&type=template&id=97b9e4c0&scoped=true"
import script from "./passed.vue?vue&type=script&lang=js"
export * from "./passed.vue?vue&type=script&lang=js"

import "./passed.vue?vue&type=style&index=0&id=97b9e4c0&scoped=true&lang=css"

import exportComponent from "E:\\余思霖\\元数创梦\\School\\Clients\\student\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-97b9e4c0"]])

export default __exports__